import { z } from "zod";
import {
  CREATED_BY,
  DATE_RANGE,
  INVOICE_STATUS,
  PAYMENT_STATUS,
  VENDOR_ID,
} from "../consts";

export const schema = z.object({
  [DATE_RANGE]: z.any().optional(),
  [VENDOR_ID]: z.any().optional(),
  [INVOICE_STATUS]: z.string().optional(),
  [CREATED_BY]: z.string().optional(),
  [PAYMENT_STATUS]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
